// api/sourceService.js
import apiClient from '../../../api/apiClient';

export const fetchLeadSources = async () => {
  try {
    const response = await apiClient.get('/lead-sources');
    return response.data;
  } catch (error) {
    console.error("Error fetching lead sources:", error);
    throw new Error("Failed to fetch lead sources");
  }
};

export const createLeadSource = async (sourceData) => {
  try {
    const response = await apiClient.post('/lead-sources', sourceData);
    return response.data;
  } catch (error) {
    console.error("Error creating lead source:", error);
    throw new Error("Failed to create lead source");
  }
};